import { matchPath, useLocation } from "react-router-dom";
import { PET_DETAILS_ID, SINGLE_PET_VIEW } from "../../../enums/UrlPaths";
import usePetViewOwnerId from "./usePetViewOwnerId";

// For components rendered outside the pet view's own route context (e.g. the
// booking modal) that need to know whether they're opened from a single pet view.
export default function usePetViewRoute() {
  const { pathname } = useLocation();
  const ownerId = usePetViewOwnerId();
  const match =
    matchPath(PET_DETAILS_ID, pathname) ?? matchPath(SINGLE_PET_VIEW, pathname);

  return {
    isPetView: Boolean(match),
    petId: match ? Number(match.params.id) : null,
    ownerId: match ? ownerId : null,
  };
}
